import { GraphQLNonNull, GraphQLFieldConfig } from 'graphql'
import { Context } from '../../shared'
import { Server, serverType } from '../../types/server'
import { findByIDAndOrganizationID } from '../../queries/helpers/server'
import {
  ServerToggleMutationArgs,
  serverToggleMutationArgs
} from '../../types/server-toggle-mutation-args'

export function createServerFeatureSetter(
  feature: 'assess' | 'protect'
): GraphQLFieldConfig<any, Context, ServerToggleMutationArgs> {
  return {
    description: `Sets the ${feature} status for a server`,
    type: new GraphQLNonNull(serverType),
    args: serverToggleMutationArgs,
    resolve: async function resolve(_source, args, context): Promise<Server> {
      const { input } = args

      if (!input) {
        throw new Error('mutation input parameter is required')
      }

      const { id, organizationID, enabled } = input

      const { connector } = context

      // first get current server feature status
      const currentServer = await findByIDAndOrganizationID(
        id,
        organizationID,
        connector
      )

      // if the desired status is equal to the current status, return the unchanged server
      if (currentServer[feature] === enabled) {
        return currentServer
      }

      // change the feature status
      await connector.put(
        `/${organizationID}/servers/${id}/${
          feature === 'assess' ? feature : 'defend'
        }`
      )
      return findByIDAndOrganizationID(id, organizationID, connector)
    }
  }
}
